/* eslint-disable no-unused-vars */
import jwt_decode from 'jwt-decode';
import React, { useEffect } from 'react';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate
} from 'react-router-dom';

import HeaderBar from './components/HeaderBar';
import LoginPage from './pages/LoginPage';
import PackageDetailsPage from './pages/PackageDetailsPage';
import PackageManagerPage from './pages/PackageManagerPage';
import ProfilePage from './pages/ProfilePage';
import RegistrationPage from './pages/RegistrationPage';
import ZoeShipmentTrackingPage from './pages/ZoeShipmentTrackingPage';

import UserRoleManagementPage from './pages/UserRoleManagementPage';
import ZoeShipmentTrackingDetailsPage from './pages/ZoeShipmentTrackingDetailsPage';
import ZoeShipmentTrackingLogPage from './pages/ZoeShipmentTrackingLogPage';
import { storageHandler } from './utils/storage_handler';

function PrivateRoute({ children, allowedUsertypes }) {
  const navigate = useNavigate();
  const token = storageHandler.localStorageGet('token');
  const usertype = parseInt(storageHandler.localStorageGet('usertype'), 10);

  useEffect(() => {
    if (token) {
      let decoded = jwt_decode(token);
      let isNotExpired = decoded.exp && decoded.exp > Date.now() / 1000;

      if (!isNotExpired) {
        storageHandler.localStorageDelete('token');
        storageHandler.localStorageDelete('usertype');
        navigate('/login');
      } else if (allowedUsertypes && !allowedUsertypes.includes(usertype)) {
        // 🚫 If usertype not allowed, redirect them away
        navigate('/');
      }
    } else {
      navigate('/login');
    }
  }, [token, usertype, allowedUsertypes, navigate]);

  return children;
}

function App() {
  return (
    <Router>
      <HeaderBar />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registration" element={<RegistrationPage />} />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <PackageManagerPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/zoe-shipment-tracking"
          element={
            <PrivateRoute>
              <ZoeShipmentTrackingPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/zoe-shipment-tracking-logs"
          element={
            <PrivateRoute allowedUsertypes={[2, 1]}>
              <ZoeShipmentTrackingLogPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/user-role-management"
          element={
            <PrivateRoute allowedUsertypes={[1]}>
              <UserRoleManagementPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/zoe-shipment-tracking/:id"
          element={
            <PrivateRoute>
              <ZoeShipmentTrackingDetailsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/package-details/:id"
          element={
            <PrivateRoute>
              <PackageDetailsPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
